"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductUrl = void 0;
const getProductUrl = code => `/products/product?code=${code}`;
exports.getProductUrl = getProductUrl;
